var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemTablet2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_\xED\x95\xAD\xEB\xAA\xA92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.3336 0.0029428C116.725 0.00295004 150.333 33.6112 150.333 75.0026L150.333 150.002L75.3336 150.002C33.9422 150.002 0.333964 116.394 0.333971 75.0025C0.333978 33.6111 33.9422 0.00293556 75.3336 0.0029428Z",
    fill: "#E4E1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9456 47.2222C10.915 47.2222 0.334652 36.6418 0.334652 23.6112V0.000183105H23.9456C36.9763 0.000183105 47.5566 10.5806 47.5566 23.6112C47.5566 36.6418 36.9763 47.2222 23.9456 47.2222Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2_2",
    d: "M30.3339 33.7523V31.575H21.1748V31.4209L25.5666 26.7581C28.9825 23.1551 29.9773 21.4402 29.996 19.2437C29.9773 16.1609 27.4998 13.7524 24.0089 13.7524C20.5367 13.7524 17.9091 16.1031 17.9278 19.5905H20.1988C20.1988 17.3748 21.644 15.8912 23.9338 15.8912C26.0922 15.8912 27.7438 17.2014 27.7626 19.2437C27.7438 21.0549 26.6552 22.3844 24.3842 24.8699L17.834 31.9604L17.8528 33.7523H30.3339Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.3047 118.677V104.567H98.5388C100.871 104.567 102.766 102.673 102.766 100.341L104.695 90.5715C104.695 90.5715 104.73 90.5101 104.739 90.4838L110.86 90.2997L108.15 79.987C108.15 77.514 107.861 74.9797 107.238 72.4541C103.406 56.8885 88.533 47.1634 74.0198 50.75C63.1371 53.4334 55.5516 62.8342 54.0696 73.9361C53.7627 76.2161 53.7188 78.5663 53.9468 80.9516C53.9556 81.048 53.9643 81.1357 53.9731 81.2322C54.0608 82.0565 54.1836 82.8808 54.3414 83.7139C54.4467 84.2839 54.5694 84.8539 54.7097 85.4239C54.9202 86.2746 55.1745 87.1076 55.4464 87.9144C55.6656 88.5634 55.8936 89.2123 56.1567 89.8349C56.7355 91.2468 57.4107 92.5885 58.1736 93.8688C58.4016 94.2546 58.6559 94.623 58.9102 95C60.287 97.0871 61.883 98.9813 63.672 100.621V118.677",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M90.1832 118.677H88.4293V103.691H98.5403C100.382 103.691 101.89 102.191 101.89 100.341L101.908 100.174L103.951 90.1068L104.197 89.6771L104.714 89.6158L109.73 89.4667L107.275 80.1098V79.9958C107.275 77.5404 106.985 75.0762 106.389 72.6734C104.582 65.3598 100.242 59.1423 94.1469 55.1611C88.0785 51.1886 81.0017 49.9258 74.223 51.6007C63.9892 54.1263 56.4213 62.9395 54.9305 74.059C54.6323 76.2951 54.5885 78.5839 54.8165 80.8727L54.8428 81.1621C54.9305 81.9338 55.0445 82.7406 55.2023 83.5561C55.3076 84.1086 55.4216 84.6611 55.5619 85.2223C55.746 85.9853 55.9828 86.7745 56.2722 87.6514C56.5177 88.3793 56.737 88.9756 56.9562 89.5193C57.5174 90.8698 58.1751 92.1939 58.9117 93.4392C59.0784 93.711 59.2537 93.9829 59.4291 94.246L59.6221 94.5353C60.9725 96.5786 62.5247 98.4202 64.2435 99.9899L64.5329 100.253V118.695H62.779V101.025C61.069 99.4111 59.5081 97.5608 58.1576 95.5L57.9734 95.2194C57.7805 94.93 57.5876 94.6406 57.4034 94.3337C56.6142 93.0183 55.9214 91.6239 55.3251 90.1858C55.0883 89.607 54.8515 88.9756 54.5972 88.2127C54.2903 87.2919 54.0448 86.4588 53.8431 85.652C53.694 85.0645 53.5712 84.4769 53.466 83.8894C53.3081 83.03 53.1766 82.1794 53.0889 81.3463L53.0626 81.0569C52.8258 78.6366 52.8697 76.2075 53.1854 73.8397C54.7726 62.0011 62.8667 52.6092 73.8021 49.917C81.0543 48.1281 88.6222 49.4786 95.1028 53.7141C101.566 57.941 106.178 64.5267 108.081 72.2788C108.695 74.7868 109.011 77.3475 109.02 79.9081L111.975 91.1767L105.424 91.3696L103.635 100.455C103.591 103.226 101.32 105.471 98.5316 105.471H90.1744V118.704L90.1832 118.677Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M120.176 85.8798L118.939 84.6434C121.132 82.451 122.342 79.5396 122.342 76.4353C122.342 73.3309 121.132 70.4195 118.939 68.2272L120.176 66.9907C122.701 69.5163 124.087 72.8662 124.087 76.4353C124.087 80.0044 122.693 83.3631 120.176 85.8798Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M117.192 82.8991L115.955 81.6627C117.349 80.2683 118.121 78.4092 118.121 76.4361C118.121 74.463 117.349 72.6039 115.955 71.2096L117.192 69.9731C118.919 71.7007 119.866 73.9895 119.866 76.4361C119.866 78.8828 118.919 81.1716 117.192 82.8991Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M114.211 79.9179L112.975 78.6727C113.571 78.0764 113.904 77.2784 113.904 76.4365C113.904 75.5946 113.571 74.7966 112.975 74.2003L114.211 72.9551C115.141 73.8846 115.649 75.1211 115.658 76.4365C115.658 77.7519 115.149 78.9884 114.211 79.9179Z",
    fill: "#F58B93"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 145",
    cx: 81.543,
    cy: 64.7051,
    rx: 10.7597,
    ry: 10.7597,
    fill: "#EAEAF9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.0576 85.8662C38.6022 83.2792 37.2955 79.8943 37.3745 76.3252C37.4622 72.756 38.9354 69.4412 41.5136 66.9771L42.7238 68.2486C40.4788 70.3883 39.1985 73.2734 39.1283 76.369C39.0582 79.4646 40.1894 82.4111 42.3291 84.656L41.0576 85.8662Z",
    fill: "#8FDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M44.1194 82.9534C42.4357 81.1907 41.5412 78.8668 41.6026 76.429C41.664 73.9823 42.6724 71.7111 44.4351 70.0361L45.6452 71.3077C44.2158 72.6669 43.4003 74.4997 43.3564 76.4728C43.3126 78.4459 44.0317 80.3226 45.3909 81.752L44.1194 82.9621V82.9534Z",
    fill: "#8FDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M47.1689 80.0429C46.2656 79.0959 45.7833 77.8506 45.8096 76.5352C45.8447 75.2198 46.3884 74.0009 47.3355 73.0889L48.5456 74.3604C47.9318 74.948 47.581 75.7284 47.5635 76.5791C47.5459 77.4209 47.8529 78.2277 48.4404 78.8415L47.1689 80.0517V80.0429Z",
    fill: "#8FDAE2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M99.5047 43.7524H85.465C84.2986 43.7524 83.3516 44.6995 83.3516 45.8658V56.9678C83.3516 58.1341 84.2986 59.0812 85.465 59.0812H89.4199L92.4892 64.3954L95.5585 59.0812H99.5134C100.68 59.0812 101.627 58.1341 101.627 56.9678V45.8658C101.627 44.6995 100.68 43.7524 99.5134 43.7524H99.5047Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M96.3576 50.5566H88.6055V52.3105H96.3576V50.5566Z",
    fill: "#C3A1F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M42.3302 94.7979H39.7695V96.5517H42.3302V94.7979Z",
    fill: "#2F4382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M47.338 94.7979H44.7773V96.5517H47.338V94.7979Z",
    fill: "#2F4382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M52.3458 94.7979H49.7852V96.5517H52.3458V94.7979Z",
    fill: "#2F4382"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M109.01 57.718H107.227C106.797 57.718 106.459 57.381 106.459 56.952C106.459 56.5231 106.797 56.186 107.227 56.186H109.01C109.44 56.186 109.778 56.5231 109.778 56.952C109.778 57.381 109.44 57.718 109.01 57.718Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M113.944 57.718H112.161C111.731 57.718 111.393 57.381 111.393 56.952C111.393 56.5231 111.731 56.186 112.161 56.186H113.944C114.374 56.186 114.712 56.5231 114.712 56.952C114.712 57.381 114.374 57.718 113.944 57.718Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M110.577 56.1543C110.147 56.1543 109.809 55.8173 109.809 55.3883V53.6112C109.809 53.1822 110.147 52.8452 110.577 52.8452C111.007 52.8452 111.345 53.1822 111.345 53.6112V55.3883C111.345 55.8173 111.007 56.1543 110.577 56.1543Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M110.577 61.0722C110.147 61.0722 109.809 60.7352 109.809 60.3063V58.5292C109.809 58.1002 110.147 57.7632 110.577 57.7632C111.007 57.7632 111.345 58.1002 111.345 58.5292V60.3063C111.345 60.7352 111.007 61.0722 110.577 61.0722Z",
    fill: "#C3A1F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M65.197 46.2378H53.7969V47.9917H65.197V46.2378Z",
    fill: "#2F4382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M59.4969 49.7437H53.7969V51.4975H59.4969V49.7437Z",
    fill: "#2F4382"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M100.598 75.9321C100.598 77.1335 99.6243 78.0982 98.4316 78.0982C97.239 78.0982 96.2656 77.1248 96.2656 75.9321C96.2656 74.7395 97.239 73.7661 98.4316 73.7661C99.6243 73.7661 100.598 74.7395 100.598 75.9321Z",
    fill: "#3C2163"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTablet2);
export default __webpack_public_path__ + "static/media/item_tablet_2.7115dd257f737c7489660c7fb97bcd29.svg";
export { ForwardRef as ReactComponent };